<template>
	<article class="question">
		<div class="site-wrapper rythm-v" v-if="reference">
			<header>
				<h1>{{ reference.title }}</h1>
				<p>
					<em><strong>Question</strong> &quot;{{ question.title }}&quot;</em>
				</p>
			</header>

			<div class="section--questions rythm-v">
				<div class="toolbar">
					<router-link :to="`/question/${questionID}`" class="button--outline">
						<svg role="img" class="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
							<path
								fill="currentColor"
								d="M7.29289 15.7071C7.68342 16.0976 8.31658 16.0976 8.70711 15.7071C9.09763 15.3166 9.09763 14.6834 8.70711 14.2929L3.41421 9L15 9C15.5523 9 16 8.55229 16 8C16 7.44772 15.5523 7 15 7L3.41421 7L8.70711 1.70711C9.09763 1.31658 9.09763 0.683418 8.70711 0.292894C8.31658 -0.0976312 7.68342 -0.0976312 7.29289 0.292894L0.292894 7.29289C-0.0976312 7.68342 -0.0976312 8.31658 0.292894 8.70711L7.29289 15.7071Z"
							/>
						</svg>
						<span class="caption">Retour</span></router-link
					>
				</div>

				<div class="card shadow">
					<div v-html="reference.content"></div>
					<div v-html="reference.authors"></div>
				</div>
			</div>
		</div>
	</article>
</template>

<style lang="scss" scoped>
h1 {
	text-transform: none;
}
</style>

<script>
export default {
	name: "Reference",

	props: ["questionID", "refID"],

	data: function() {
		return {
			question: {},
			reference: null
		};
	},

	methods: {
		// Load reference
		getReference: function() {
			let refID = this.refID;

			this.$store
				.dispatch("GET_REFERENCE", refID)
				.then(response => {
					this.reference = response;
				})
				.catch(error => {
					console.log("getReference error…", error);
					// eventHub.$emit("network-error", error.response);
				});
		},

		// Load question
		getQuestion: function() {
			this.$store
				.dispatch("GET_QUESTION_DATA", this.questionID)
				.then(response => {
					this.question = response;
				})
				.catch(error => {
					console.log("getQuestion error…", error);
					// eventHub.$emit("network-error", error.response);
				});
		}
	},

	mounted() {
		// Load question and reference
		if (this.questionID > 0) this.getQuestion();
		if (this.refID > 0) this.getReference();
	}
};
</script>
